// Alpine plugins
import Alpine from 'alpinejs';
import AlpineFloatingUI from '@awcodes/alpine-floating-ui';
import FileUploadFormComponentAlpinePlugin from '../../vendor/filament/forms/resources/js/components/file-upload';
import NotificationsAlpinePlugin from '../../vendor/filament/notifications/dist/module.esm';
import SelectFormComponentAlpinePlugin from '../../vendor/filament/forms/resources/js/components/select';
import TextareaFormComponentAlpinePlugin from '../../vendor/filament/forms/resources/js/components/textarea';
import TextInputFormComponentAlpinePlugin from '../../vendor/filament/forms/resources/js/components/text-input';
import '../../vendor/filament/forms/dist/module.esm.css';

window.Alpine       = Alpine;
window.formsEnabled = false;
const plugins       = [
  SelectFormComponentAlpinePlugin,
  TextInputFormComponentAlpinePlugin,
  AlpineFloatingUI,
  FileUploadFormComponentAlpinePlugin,
  TextareaFormComponentAlpinePlugin,
  NotificationsAlpinePlugin
];
const enableForms   = async () => {
  if (window.formsEnabled) return;

  plugins.forEach(plugin => Alpine.plugin(plugin));

  // DO NOT START BEFORE window.Alpine IS DEFINED
  Alpine.start();

  window.formsEnabled = true;

  console.log('Forms enabled');
};

window.delay(() => {
  _qa('.form[wire\\:id]').forEach(el => el.addEventListener('click', enableForms));
  _qa('.form[wire\\:id] *').forEach(el => el.addEventListener('focus', enableForms));
});
